import React, { useEffect, useState } from "react"
import Header from "../../../components/navigation/Header"
import Footer from "../../../components/navigation/Footer"
import { Link, useSearchParams} from "react-router-dom"
import axios from "axios"
import CreateCSFR from "../../../hooks/userAuthentication/CreateCSFR"
import LoadingAnimation from "../../../components/general/LoadingAnimation"

export default function NewsletterUnsubscribe(){
    const csrfToken = CreateCSFR({ name: "csrftoken" })
    const [unsubscribed, setUnsubscribed] = useState<boolean>(false)
    const [displayMessage, setDisplayMessage] = useState<string>("You have successfully unsubscribed from our newsletter!")
    const [searchParams] = useSearchParams()
    const userId = searchParams.get("id")  
    
    function unsubscribe(){
        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/newsletter/unsubscribe/`, {id: userId}, {
            headers: {
                "X-CSRFToken": csrfToken,
            },
            withCredentials: true,
        })
        .then((res) => {
            if (res.status !== 200) {
                setUnsubscribed(false)
                setDisplayMessage("Oops! Something went wrong please contact support@skillja.ca")
            }
        })
        .catch((error) => { 
            console.error(error)
            setUnsubscribed(false)
            setDisplayMessage("Oops! Something went wrong. Please contact support@skillja.ca")
        })
        .finally(()=>setUnsubscribed(true))
    }

    useEffect(()=>{
        if (!userId) {
            setDisplayMessage("Invalid link. Please contact support@skillja.ca")
            return
        }

        if (!csrfToken) return

        const timer = setTimeout(() => {
            unsubscribe()
        }, 1500)

        return ()=> clearTimeout(timer)
    },[csrfToken])

    return (
        <div>
            <Header useCase="onboarding" />
            <section>
                {unsubscribed ?
                    <div className="flex flex-col justify-center items-center my-32">
                        <p className="px-4 text-lg text-center mx-auto my-8">
                            {displayMessage}
                        </p>
                        <Link to={'/'} className="form-btn px-4 py-2">
                            Home
                        </Link>
                    </div>
                :
                    <div className="my-32">
                        <LoadingAnimation />
                    </div>
                }
            </section>
            <Footer />
        </div>
    )
}